import { ref as f, computed as c } from "vue";
import F from "../../node_modules/ramda/es/pipe.mjs";
import V from "../../node_modules/ramda/es/split.mjs";
import m from "../../node_modules/ramda/es/lensPath.mjs";
import n from "../../node_modules/ramda/es/view.mjs";
import i from "../../node_modules/ramda/es/set.mjs";
const b = F(V("."), (l) => m(l));
function x(l, u) {
  const s = f(l.value), r = f({}), v = c(() => s.value), d = c(() => r.value), p = () => {
    if (r.value = {}, !u)
      return !0;
    const e = u == null ? void 0 : u.safeParse(s.value);
    if (e != null && e.success)
      return !0;
    const o = e.error.errors;
    for (const t of o) {
      const a = {
        isError: !0,
        message: t.message
      };
      r.value = i(m(t.path), a, r.value);
    }
    return !1;
  };
  return { register: (e) => {
    var t, a;
    const o = b(e);
    return {
      modelValue: n(o, s.value),
      error: (t = n(o, r.value)) == null ? void 0 : t.isError,
      errorMessage: (a = n(o, r.value)) == null ? void 0 : a.message,
      "onUpdate:modelValue": (g) => {
        s.value = i(o, g, s.value), r.value = i(o, { isError: !1, message: "" }, r.value);
      }
    };
  }, handleSubmit: (e) => p() ? (e(s.value), { success: !0 }) : { success: !1 }, watcher: v, errorWatch: d };
}
export {
  x as useForm
};
